// Copyright (c) 2018 Deere & Company

import ExcelLayoutSortBy from '@deere/cps-it.warranty-model-factory/lib/excel-layout-sort-by';

export const getUpdatedSortBy = (column, direction) =>
    new ExcelLayoutSortBy({
        column,
        direction
    });



// WEBPACK FOOTER //
// ./src/shared/components/excel-layout/services/get-updated-sort-by.js